import { Pipe, PipeTransform } from '@angular/core';
import { AppService } from '@core/services/app/app.service';

export type AssetCategory = 'images' | 'icons';

export type AssetFileType = 'svg' | 'png' | 'jpg' | 'jpeg';

@Pipe({
  name: 'srcAssets'
})
export class SrcAssetsPipe implements PipeTransform {
  constructor(private appService: AppService) {}

  transform(
    name: string,
    category: AssetCategory = 'images',
    fileType: AssetFileType = 'svg'
  ): string {
    return this.buildSrc({
      name,
      category,
      fileType
    });
  }

  private buildSrc(options: {
    name?: string;
    category?: AssetCategory;
    fileType?: AssetFileType;
  }): string {
    let src = `./assets/`;

    if (options.category) {
      src += `${options.category}/`;
    }

    if (options.name) {
      src += `${options.name}`;
    }

    if (options.fileType) {
      src += `.${options.fileType}`;
    }

    if (!!this.findAlias(src)) {
      return this.findAlias(src);
    } else {
      return src;
    }
  }

  private findAlias(src: string): string {
    const srcAlias = this.appService.getConfig().theme.srcAlias;

    if (!!srcAlias && !!srcAlias[src]) {
      return srcAlias[src];
    } else {
      return null;
    }
  }
}
